import React from 'react'
import { useQuery } from 'react-query'
import { indexBy, pathOr, prop } from 'ramda'
import { IGoodsTransport } from './options.type'

export const useGoodsTransport = () => {
  const { data, isLoading, refetch } = useQuery<IGoodsTransport[]>(
    ['/options/goodsTransCategories'],
    {
      select: data => {
        return pathOr([], ['data'], data)
      },
    }
  )

  const byId = React.useMemo(() => {
    return indexBy(prop('id'), data || [])
  }, [data])

  return { data, isLoading, refetch, byId }
}
